(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elena-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elena-gallery')){
 customElements.define('elena-gallery',class extends HTMLElement{
  connectedCallback(){this.initFrame=requestAnimationFrame(()=>this.initialize())}
  initialize(){
   if(this.controller)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};
   this.track=this.querySelector('.elena-gallery__track');if(!this.track){this.controller=null;return;}
   this.cards=Array.from(this.track.children);if(!this.cards.length){this.controller=null;return;}
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.loop=this.cards.length>1;
   if(this.loop){
    const copy=()=>{const fragment=document.createDocumentFragment();this.cards.forEach(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.inert=true;clone.removeAttribute('data-shopify-editor-block');clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));fragment.append(clone)});return fragment};
    this.track.prepend(copy());this.track.append(copy());
   }
   this.measure=()=>{const first=this.cards[0];this.span=this.loop?this.cards[this.cards.length-1].offsetLeft-first.offsetLeft+first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap):0;this.position=first.offsetLeft-this.track.firstElementChild.offsetLeft-(this.track.clientWidth-first.getBoundingClientRect().width)/2;this.track.scrollLeft=this.position;this.last=0};
   this.resize=new ResizeObserver(()=>{const width=this.track.clientWidth;if(width!==this.measuredWidth){this.measuredWidth=width;this.measure()}});this.resize.observe(this.track);this.measure();
   this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),options);
   this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),options);
   this.track.addEventListener('pointerdown',()=>{this.dragging=true},options);
   window.addEventListener('pointerup',()=>{if(this.dragging){this.dragging=false;this.pauseUntil=performance.now()+1500;this.position=this.track.scrollLeft}},options);
   this.track.addEventListener('pointercancel',()=>{this.dragging=false;this.pauseUntil=performance.now()+1500},options);
   this.track.addEventListener('wheel',()=>{this.pauseUntil=performance.now()+1500}, {...options,passive:true});
   this.track.addEventListener('scroll',()=>{if(this.dragging||performance.now()<(this.pauseUntil||0))this.position=this.track.scrollLeft},options);
   this.tick=(time)=>{this.frame=null;if(!this.running)return;const delta=Math.min(time-(this.last||time),50);this.last=time;
    if(this.loop&&this.dataset.autoplay==='true'&&!this.reduced.matches&&!document.hidden&&!this.dragging&&time>=(this.pauseUntil||0)&&!this.querySelector(':focus-visible')){
     this.position+=delta*0.024;
     if(this.position<this.span/2)this.position+=this.span;
     if(this.position>this.span*1.5)this.position-=this.span;
     this.track.scrollLeft=this.position;
    }
    this.frame=requestAnimationFrame(this.tick);
      };
   this.visible=false;this.running=false;
   this.visibilityObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.updatePlayback()},{threshold:0});
   this.visibilityObserver.observe(this.track);
   document.addEventListener('visibilitychange',()=>this.updatePlayback(),options);
  }
  updatePlayback(){
   const shouldRun=this.visible&&!document.hidden&&this.loop&&this.dataset.autoplay==='true'&&!this.reduced.matches;
   this.running=shouldRun;
   if(!shouldRun){cancelAnimationFrame(this.frame);this.frame=null;this.last=0;return;}
   if(this.frame==null){this.last=0;this.frame=requestAnimationFrame(this.tick);}
  }
  move(direction){this.pauseUntil=performance.now()+1500;const step=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);this.position=this.track.scrollLeft+direction*step;if(this.loop){if(this.position<this.span/2)this.position+=this.span;if(this.position>this.span*1.5)this.position-=this.span}this.track.scrollTo({left:this.position,behavior:this.reduced.matches?'auto':'smooth'})}
  disconnectedCallback(){cancelAnimationFrame(this.initFrame);this.controller?.abort();this.controller=null;cancelAnimationFrame(this.frame);this.resize?.disconnect();this.visibilityObserver?.disconnect();this.running=false;this.frame=null;this.track?.querySelectorAll('[aria-hidden="true"]').forEach(card=>card.remove())}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elena-promo-rotation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elena-promo-rotation')) {
    customElements.define('elena-promo-rotation', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.items = Array.from(this.querySelectorAll('[data-promo-item]'));
        this.index = Math.max(0, this.items.findIndex(item => item.classList.contains('is-active')));
        if (this.items.length < 2) return;
        this.timer = setInterval(() => {
          if (document.hidden) return;
          this.items[this.index].classList.remove('is-active');
          this.items[this.index].setAttribute('aria-hidden', 'true');
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
          this.items[this.index].removeAttribute('aria-hidden');
        }, 4000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elena-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elena-reviews')){
 customElements.define('elena-reviews',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};this.track=this.querySelector('.elena-reviews__track');
   this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),options);
   this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),options);
   if(this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){this.timer=setInterval(()=>{if(!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.move(1)},Number(this.dataset.delay)||5000)}
  }
  move(direction){const width=this.track.querySelector('article')?.getBoundingClientRect().width||0;const gap=parseFloat(getComputedStyle(this.track).gap)||0;const max=this.track.scrollWidth-this.track.clientWidth;let next=this.track.scrollLeft+direction*(width+gap);if(next>max+2)next=0;if(next<0)next=max;this.track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
  disconnectedCallback(){this.controller?.abort();this.controller=null;clearInterval(this.timer)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elena-sport-chic-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elena-text-reviews'))customElements.define('elena-text-reviews',class extends HTMLElement{
 connectedCallback(){this.initFrame=requestAnimationFrame(()=>this.init())}
 init(){if(this.controller)return;this.controller=new AbortController();const opts={signal:this.controller.signal};this.track=this.querySelector('.esr-track');if(!this.track)return;this.index=0;this.pages=Math.max(1,this.track.children.length-2);this.box=this.querySelector('.esr-dots');this.box.replaceChildren();for(let n=0;n<this.pages;n++){const dot=document.createElement('button');dot.type='button';dot.className='esr-dot';dot.setAttribute('aria-label','Mergi la recenzia '+(n+1));dot.addEventListener('click',()=>this.go(n),opts);this.box.append(dot)}this.querySelector('.esr-prev').addEventListener('click',()=>this.go(this.index-1),opts);this.querySelector('.esr-next').addEventListener('click',()=>this.go(this.index+1),opts);this.resize=new ResizeObserver(()=>this.go(this.index));this.resize.observe(this);this.go(0)}
 go(n){this.index=(n+this.pages)%this.pages;const step=this.track.children[0].getBoundingClientRect().width+12;this.track.style.transform='translateX('+(-this.index*step)+'px)';Array.from(this.box.children).forEach((dot,k)=>{dot.classList.toggle('is-active',k===this.index);dot.setAttribute('aria-current',k===this.index?'true':'false')})}
 disconnectedCallback(){cancelAnimationFrame(this.initFrame);this.controller?.abort();this.controller=null;this.resize?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonial-12"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lm-testimonial-carousel')) {
    customElements.define('lm-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
        if (!this.cards.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 1023px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.current = Math.min(Number(this.dataset.initial) || 0, this.cards.length - 1);
        this.manualPause = false;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), options));
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(index, true);
          this.dots[this.current]?.focus({ preventScroll: true });
        }, options);
        const stage = this.querySelector('.lm-testimonials__stage');
        stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 || event.target.closest('a, button, input, video')) return;
          this.start = { x: event.clientX, y: event.clientY };
        }, options);
        stage.addEventListener('pointerup', (event) => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.current + (dx < 0 ? 1 : -1), true);
        }, options);
        stage.addEventListener('pointercancel', () => { this.start = null; }, options);
        this.addEventListener('mouseenter', () => this.stop(), options);
        this.addEventListener('mouseleave', () => this.play(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', () => this.play(), options);
        this.mobile.addEventListener('change', () => this.render(), options);
        this.reduced.addEventListener('change', () => { this.stop(); this.play(); }, options);
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.play(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.indexOf(event.target.closest('[data-review]'));
          if (index >= 0) this.go(index, true);
        }, options);
        this.render();
        this.play();
      }
      go(index, manual = false) {
        this.current = (index + this.cards.length) % this.cards.length;
        if (manual) { this.manualPause = true; this.stop(); }
        this.render();
      }
      render() {
        const total = this.cards.length;
        this.cards.forEach((card, index) => {
          const active = index === this.current;
          const previous = total > 1 && index === (this.current - 1 + total) % total;
          const next = total > 2 && index === (this.current + 1) % total;
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-previous', previous);
          card.classList.toggle('is-next', next);
          const visible = active || (!this.mobile.matches && (previous || next));
          card.setAttribute('aria-hidden', String(!visible));
          card.inert = !visible;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.current)));
      }
      play() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.manualPause || this.reduced.matches || document.hidden || this.matches(':hover, :focus-within') || this.cards.length < 2) return;
        this.timer = setInterval(() => this.go(this.current + 1), Math.max(Number(this.dataset.delay) || 5000, 3000));
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-footer')) {
    customElements.define('store-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.update = () => this.querySelectorAll('details').forEach(detail => { detail.open = !this.media.matches; });
        this.preventDesktopToggle = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.media.addEventListener('change', this.update);
        this.addEventListener('click', this.preventDesktopToggle);
        this.update();
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.update);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-services"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-service-strip')) {
    customElements.define('store-service-strip', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const list = this.querySelector('.store-services__list');
        const buttons = [...this.querySelectorAll('[data-service-index]')];
        const update = () => {
          const index = Math.round(list.scrollLeft / list.clientWidth);
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        };
        list.addEventListener('scroll', update, {passive: true, signal});
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          list.scrollTo({left: index * list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal}));
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
